var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      class: _vm.classes
    },
    [
      _vm.showOverlay
        ? _c("div", { class: [_vm.mdsNS("overlay"), _vm.namespace("overlay")] })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          class: [_vm.mdsNS("loader"), _vm.namespace("loader")],
          attrs: { role: "progressbar", "aria-valuetext": _vm.ariaText }
        },
        [
          _c("div", { class: _vm.mdsNS("loader__item loader__item--1") }),
          _vm._v(" "),
          _c("div", { class: _vm.mdsNS("loader__item loader__item--2") }),
          _vm._v(" "),
          _c("div", { class: _vm.mdsNS("loader__item loader__item--3") }),
          _vm._v(" "),
          _c("div", { class: _vm.mdsNS("loader__item loader__item--4") }),
          _vm._v(" "),
          _c("div", { class: _vm.mdsNS("loader__item loader__item--5") }),
          _vm._v(" "),
          _c("div", { class: _vm.mdsNS("loader__item loader__item--6") }),
          _vm._v(" "),
          _c("div", { class: _vm.mdsNS("loader__item loader__item--7") }),
          _vm._v(" "),
          _c("div", { class: _vm.mdsNS("loader__item loader__item--8") })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }